import { memo, useState } from "react";
import { Accordion } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import GeneralInfo from "./components/general-info";
import Overview from "./components/overview";

import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";
import CreditAssessment from "./components/credit-assessment";
import Financial from "./components/financial";
import Ownership from "./components/ownership";
import NegativeInfo from "./components/negative-info";
import Establishments from "./components/establishments";
import CompanyIdentification from "./components/company-identification";
import CompanySummary from "./components/company-summary";
import ContactInfo from "./components/contact-info";
import BasicInfosHeader from "../../components/basic-infos-header";

const CreditSafe = ({ t, detailsQuery, supplierData, ...elseData }) => {
    const history = useHistory();

    const [activeAccordion, setActiveAccordion] = useState(null);

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-5">
                <Button
                    color="secondary"
                    outline
                    onClick={() => {
                        history.push({
                            search: `?tab=kyb`
                        })
                    }}
                >
                    <i className="ri-arrow-left-line me-1" />
                    {t('Back to List')}
                </Button>

                {/* <Button
                    color="primary"
                    outline
                >
                    <i className="ri-download-line me-1" />
                    {t('Download PDF')}
                </Button> */}
            </div>

            <div>
                <Accordion
                    className="custom-accordion"
                    activeKey={['basic-infos', activeAccordion]}
                    defaultActiveKey={activeAccordion}
                >
                    <BasicInfosHeader
                        detailsQuery={detailsQuery}
                    />

                    <CompanyIdentification 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <CompanySummary 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <ContactInfo 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />
                    
                    <Overview 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <CreditAssessment 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <Financial 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <Ownership 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <NegativeInfo 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    <Establishments 
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    />

                    {/* <GeneralInfo
                        setActiveAccordion={setActiveAccordion}
                        activeAccordion={activeAccordion}
                        detailsQuery={detailsQuery}
                    /> */}
                </Accordion>
            </div>
        </div>
    )
}

const mapStatetoProps = (state) => {
    return {
        organization  :   state.Organization,
        user: state.Login
    };
};

export default withNamespaces()(
    withRouter(connect(
        mapStatetoProps,
        {}
    )(memo(CreditSafe)))
);
